const SHOP_DOMAIN = 'hout-bewerking.myshopify.com';
const STOREFRONT_ACCESS_TOKEN = '187d2c2294cce34249a364fcbbd74cd1';
const ENDPOINT = `https://${SHOP_DOMAIN}/api/2023-10/graphql.json`;

// Product query (zonder varianten)
const productQuery = `
  query getProducts($cursor: String) {
    products(first: 100, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          title
          handle
          options {
            name
          }
          metafields(identifiers: [
            { namespace: "custom", key: "calculator_type" },
            { namespace: "custom", key: "calculator_group" },
            { namespace: "custom", key: "calculator_m2_per_pak" }
          ]) {
            key
            value
          }
        }
      }
    }
  }
`;

// Variant query per product
const variantsQuery = `
  query getVariants($productId: ID!, $cursor: String) {
    product(id: $productId) {
      variants(first: 100, after: $cursor) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            title
            price {
              amount
            }
            selectedOptions {
              name
              value
            }
            metafields(identifiers: [
              { namespace: "custom", key: "lengtes" }
            ]) {
              key
              value
            }
          }
        }
      }
    }
  }
`;

// Shopify API call
async function callShopify(query, variables = {}) {
  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });

  const json = await res.json();
  if (json.errors) {
    console.error('❌ Shopify GraphQL Error:', json.errors);
    throw new Error('GraphQL error');
  }

  return json.data;
}

// Variants ophalen per product (met paginatie)
async function fetchAllVariants(productId) {
  let variants = [];
  let hasNextPage = true;
  let cursor = null;

  while (hasNextPage) {
    const data = await callShopify(variantsQuery, { productId, cursor });

    const vEdges = data?.product?.variants?.edges || [];

    vEdges.forEach(edge => {
      const v = edge.node;

      const lengtes = (v.metafields || [])
        .filter(f => f && f.key)
        .find(f => f.key === 'lengtes')?.value || '';

      variants.push({
        id: v.id,
        title: v.title,
        price: v.price.amount,
        option1: v.selectedOptions[0]?.value || '',
        option2: v.selectedOptions[1]?.value || '',
        option3: v.selectedOptions[2]?.value || '',
        lengtes
      });
    });

    hasNextPage = data.product.variants.pageInfo.hasNextPage;
    cursor = hasNextPage ? vEdges[vEdges.length - 1].cursor : null;
  }

  return variants;
}

// Main: producten + varianten ophalen met Promise.all
async function fetchAllProducts() {
  let products = [];
  let hasNextPage = true;
  let cursor = null;

  while (hasNextPage) {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({
        query: productQuery,
        variables: { cursor }
      })
    });

    const json = await res.json();
    if (!json?.data?.products) {
      console.error('❌ Fout in API-response:', json.errors || json);
      break;
    }

    const edges = json.data.products.edges;

    // 🔁 Parallel variant-ophaal per product
    const productBatch = await Promise.all(edges.map(async (edge) => {
      const node = edge.node;

      const metafields = (node.metafields || []).filter(Boolean);
      const calculatorType = metafields.find(f => f.key === 'calculator_type')?.value || null;
      const calculatorGroup = metafields.find(f => f.key === 'calculator_group')?.value || null;
      const calculatorM2PerPak = metafields.find(f => f.key === 'calculator_m2_per_pak')?.value || null;

      let variants = [];
      try {
        variants = await fetchAllVariants(node.id);
      } catch (err) {
        console.error(`❌ Fout bij varianten voor ${node.title}`, err);
      }

      return {
        id: node.id,
        title: node.title,
        handle: node.handle,
        options: node.options.map(o => o.name),
        calculator_type: calculatorType,
        calculator_group: calculatorGroup,
        calculator_m2_per_pak: calculatorM2PerPak,
        variants
      };
    }));

    // Voeg batch toe aan alle producten
    products.push(...productBatch);

    hasNextPage = json.data.products.pageInfo.hasNextPage;
    cursor = edges.length > 0 ? edges[edges.length - 1].cursor : null;
  }

  return products;
}

// Gebruik
// fetchAllProducts().then(products => console.log(products)).catch(console.error);
